import { Injectable } from '@angular/core';
import { ReviewEntity } from '@models';
import { BaseApi } from './_base-api';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ReviewApiService extends BaseApi<ReviewEntity> {
  constructor() {
    super('Reviews', {
      get: '/AdminPanel/GetReviewList',
    });
  }

  // @ts-ignore
  override delete(ids: number | number[]) {
    const idsArray = typeof ids === 'number' ? [ids] : ids;
    return http$.delete('/AdminPanel/DeleteReview', { body: { reviewIds: idsArray } });
  }

  changeReviewStatus(ids: number | number[], status: 1 | 0) {
    const idsArray = typeof ids === 'number' ? [ids] : ids;
    const model = {
      ids: idsArray,
      reviewStatus: status,
    };
    return http$.patch('/AdminPanel/ChangeReviewStatus', model);
  }
}
